export default __webpack_public_path__ + "static/media/include_4@2x.e6e59620.jpg";